export const FLAGS = {
	app: {
		maintenanceMode: "fe.app.maintenance_mode",
	},
	vessels: {
		list: {
			addButtonLabel: "fe.vessel.list.add_button_label",
			optInColumnVisible: "fe.vessel.list.opt_in_column_visible",
		},
		overview: {
			accessUsersVisible: "fe.vessel.overview.access_users_visible",
		},
		form: {
			moduleAccessVisible: "fe.vessel.form.module_access_visible",
			moduleFetchEnabled: "fe.vessel.form.module_fetch_enabled",
			distributorFieldVisible: "fe.vessel.form.distributor_field_visible",
			activationEnabledVisible: "fe.vessel.form.activation_enabled_visible",
		},
		kitActivation: {
			optInVisible: "fe.vessel.kit_activation.opt_in_visible",
			commitmentVisible: "fe.vessel.kit_activation.commitment_visible",
		},
		kitNumberList: {
			viewLogBtnVisible: "fe.vessel.kit_number_list.view_log_btn_visible",
		},
		VoucherService: {
			vouchersPerDayVisible: "fe.vessel.vouchers_service.view_vouchers_graph_visible",
		},
	},

	clients: {
		list: {
			distributorColumnVisible: "fe.clients.list.distributor_column_visible",
		},
		form: {
			moduleAccessVisible: "fe.clients.form.module_access_visible",
			commercialEmailRequired: "fe.clients.form.commercial_email_required",
			distributorSectionVisible: "fe.clients.form.distributor_section_visible",
			distributorTypeFilterEnabled: "fe.clients.form.distributor_type_filter_enabled",
			distributorValuesAutoSetEnabled: "fe.clients.form.distributor_values_auto_set_enabled",
			distributorFetchOnEditEnabled: "fe.clients.form.distributor_fetch_on_edit_enabled",
			buIdAutoSelectEnabled: "fe.clients.form.bu_id_auto_select_enabled",
			moduleFetchEnabled: "fe.clients.form.module_fetch_enabled",
		},
	},

	distributors: {
		form: {
			moduleFetchEnabled: "fe.distributors.form.module_fetch_enabled",
			logoRequired: "fe.distributors.form.logo_required",
			moduleAccessVisible: "fe.distributors.form.module_access_visible",
			typeInPayloadEnabled: "fe.distributors.form.type_in_payload_enabled",
		},
	},

	stocks: {
		list: {
			resellerColumnVisible: "fe.stocks.list.reseller_column_visible",
			distributorSelectForDistributorRoleEnabled:
				"fe.stocks.list.distributor_select_for_distributor_role_enabled",
		},
		downloadTemplate: {
			businessUnitValue: "fe.stocks.download_template.business_unit_value",
		},
		formDevice: {
			distributorTypeFilterEnabled: "fe.stocks.form_device.distributor_type_filter_enabled",
			resellerSectionVisible: "fe.stocks.form_device.reseller_section_visible",
		},
		assignDeassignModal: {
			clientCompanyFiltersEnabled: "fe.stocks.assign_deassign_modal.client_company_filters_enabled",
		},
	},

	users: {
		list: {
			roleColumnVisible: "fe.users.list.role_column_visible",
		},
		form: {
			adistaLayoutEnabled: "fe.users.form.adista_layout_enabled",
			distributorPrefetchEnabled: "fe.users.form.distributor_prefetch_enabled",
			companyIdInPayloadEnabled: "fe.users.form.company_id_in_payload_enabled",
			distributorFieldValidationEnabled: "fe.users.form.distributor_field_validation_enabled",
			resellerCompanyIdInPayloadEnabled: "fe.users.form.reseller_company_id_in_payload_enabled",
			distributorFieldVisible: "fe.users.form.distributor_field_visible",
		},
		roles: {
			adistaDisplayEnabled: "fe.users.roles.adista_display_enabled",
		},
	},

	sidebar: {
		adminAccess: {
			distributorAllowlist: "fe.sidebar.admin_access.distributor_allowlist",
		},
		accountManagement: {
			usersVisible: "fe.sidebar.account_management.users_visible",
		},
	},

	profile: {
		role: {
			descriptionVisible: "fe.profile.role.description_visible",
		},
	},

	shared: {
		vessels: {
			titlesConfig: "fe.shared.vessels.titles_config",
		},
		distributorsFilter: {
			typeFilterEnabled: "fe.shared.distributors_filter.type_filter_enabled",
		},
		clients: {
			resellerFetchEnabled: "fe.clients.form.reseller_fetch_enabled",
		},
		distributors: {
			businessUnitVisible: "fe.distributors.form.business_unit_visible",
		},
		filters: {
			distributorFilterVisible: "fe.shared.filters.distributor_filter_visible",
			businessUnitFilterVisible: "fe.shared.filters.business_unit_filter_visible",
			rolesFilterVisible: "fe.shared.filters.roles_filter_visible",
		},
	},
};
